import { ConfigFn } from '@config/types'

const config = (({ publication }) => {
  const iosBlickAppId = 375173494
  const iosRomandieAppId = 1596317983
  return {
    iosAppId: publication === 'romandie' ? iosRomandieAppId : iosBlickAppId,
    android:
      publication === 'romandie'
        ? 'https://play.google.com/store/apps/details?id=ch.blick.news.fr'
        : 'https://play.google.com/store/apps/details?id=ch.blick.news',
    ios:
      publication === 'romandie'
        ? `https://apps.apple.com/ch/app/blick-fr/id${iosRomandieAppId}`
        : `https://apps.apple.com/ch/app/blick-news-sport/id${iosBlickAppId}`,
    iosDeepLinkBaseUrl: `blick${
      publication === 'romandie' ? 'fr' : ''
    }://article`,
  } as const
}) satisfies ConfigFn

export default config
